import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";

function VctAppointmentDiffDaysModal(props) {
  const onCancel = () => {
    props.hideModal();
  };

  return (
    <ConfirmationModal
      message={`Los volantes tienen una fecha de retiro distinta, edita la fecha de retiro para poder programar la cita.`}
      onAccept={() => {
        onCancel();
      }}
      title={`Debes modificar la fecha de retiro`}
      toggleModal={() => {
        onCancel();
      }}
    />
  );
}

export default VctAppointmentDiffDaysModal;
